import { css } from 'styled-components';
// This should match the gradient used by UIDialogHeader:
// https://git.hubteam.com/HubSpot/foundations-components/blob/e45a37e2c8a37f39bcbb8a88cb6c142c3a78bc9b/foundations-components/static/js/transitional/components/DialogHeader/DialogHeader.tsx#L56
// @bend-expect trellis-tokenized
export const dialogHeaderGradient = css(({
  theme
}) => `linear-gradient(-303deg, ${theme.color['fill-secondary-default']}, ${theme.color['fill-positive-default']})`);